import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { affiliatesAPI } from '../../lib/api';
import { t } from '../../lib/i18n';
import { btnGhost, EmptyState, inputCls, panelCls } from '../../components/ui';
import { nyTime } from '../../lib/nyTime';

export default function FlagsPage() {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState('open');

  const load = useCallback(() => {
    affiliatesAPI.flags({ status })
      .then(({ data }) => setData(data))
      .catch(() => toast.error(t('Could not load flags')));
  }, [status]);
  useEffect(load, [load]);

  const resolve = async (f) => {
    try {
      await affiliatesAPI.resolveFlag(f.id);
      toast.success(t('Done'));
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || t('Action failed'));
    }
  };

  return (
    <div>
      <h1 className="mb-4 text-lg font-semibold">{t('Fraud flags')}</h1>
      <div className="mb-3">
        <select className={`${inputCls} !w-40`} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="open">{t('open')}</option>
          <option value="resolved">{t('resolved')}</option>
          <option value="">{t('All statuses')}</option>
        </select>
      </div>
      {data === null ? (
        <p className="text-sm text-mms-muted">{t('Loading…')}</p>
      ) : data.items.length === 0 ? (
        <EmptyState>{t('No fraud flags — quiet is good.')}</EmptyState>
      ) : (
        <div className={`${panelCls} overflow-x-auto`}>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-mms-border text-left text-xs text-mms-faint">
                <th className="px-4 py-2.5 font-medium">{t('When')}</th>
                <th className="px-4 py-2.5 font-medium">{t('Kind')}</th>
                <th className="px-4 py-2.5 font-medium">{t('Affiliate')}</th>
                <th className="px-4 py-2.5 font-medium">{t('Detail')}</th>
                <th className="px-4 py-2.5" />
              </tr>
            </thead>
            <tbody>
              {data.items.map((f) => (
                <tr key={f.id} className="border-b border-mms-border/60 last:border-0">
                  <td className="px-4 py-2.5 whitespace-nowrap text-xs text-mms-muted">
                    {nyTime(f.at)}
                  </td>
                  <td className="px-4 py-2.5"><code className="text-xs">{f.kind}</code></td>
                  <td className="px-4 py-2.5">{f.affiliate?.name || '—'}</td>
                  <td className="px-4 py-2.5 text-xs text-mms-muted">{f.detail}</td>
                  <td className="px-4 py-2.5 text-right">
                    {f.status === 'open' && (
                      <button onClick={() => resolve(f)} className={btnGhost}>{t('Resolve')}</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
